module.exports = __webpack_public_path__ + "static/media/A_GD_Holz_Merkblatt_Lieferanten_ENG_v1.1.6ac3f214.pdf";